import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Box, ConfirmationModal, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
export const GetDuplicateNameModalTID = (parentTestId)=>getTestIds(parentTestId);
export const DuplicateNameModal = (param)=>{
    let { existingName, dismissModal, onEditName, onOverride } = param;
    const { t } = useLocaleKeys();
    const testIds = useMemo(()=>GetDuplicateNameModalTID(), []);
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        title: t.customPages.saveAsTemplateModal.duplicateTitle(),
        testId: testIds.DuplicateNameModalTestIds.Root(),
        onCloseButtonClick: dismissModal,
        width: "500px",
        primaryButtonLabel: t.customPages.saveAsTemplateModal.overrideButton(),
        primaryButtonTestId: testIds.DuplicateNameModalTestIds.OverrideButton(),
        primaryButtonIntent: "destructive",
        onPrimaryButtonClick: onOverride,
        secondaryButtonLabel: t.customPages.saveAsTemplateModal.editNameButton(),
        secondaryButtonTestId: testIds.DuplicateNameModalTestIds.EditNameButton(),
        onSecondaryButtonClick: onEditName,
        content: /*#__PURE__*/ _jsx(Box, {
            testId: testIds.DuplicateNameModalTestIds.Message(),
            children: /*#__PURE__*/ _jsx(Typography, {
                children: t.customPages.saveAsTemplateModal.duplicateMessage({
                    name: existingName
                })
            })
        })
    });
};
